/* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createLocalizationTranslationProviderValidator } from "../localizationTranslationProviders/SWBaseLocalizationTranslationProvider";
/** @internal */ export const rootLocalizationTranslationProviderVersions = {};
/** @internal */ export const rootLocalizationTranslationProviderMigrations = defineMigrations({});
/** @public */ export function isLocalizationTranslationProvider(record) {
    if (!record) return false;
    return record.typeName === "localization_provider";
}
/** @public */ export function isLocalizationTranslationProviderId(id) {
    if (!id) return false;
    return id.startsWith("localization_provider:");
}
/** @public */ export function createLocalizationTranslationProviderId({ type, projectIdentifier, organizationId }) {
    return `localization_provider:${[
        type,
        organizationId,
        projectIdentifier
    ].join(":")}`;
}
/** @public */ export function parseLocalizationTranslationProviderId(id) {
    if (!id) return undefined;
    if (!id.startsWith("localization_provider:")) return undefined;
    // Split into many pieces
    const parts = id.replace("localization_provider:", "").split(":");
    const type = parts.shift();
    const organizationId = parseInt(parts.shift() || "");
    const projectIdentifier = parts.join(":");
    if (isNaN(organizationId)) return undefined;
    return {
        type: type,
        organizationId,
        projectIdentifier: projectIdentifier
    };
}
/** @internal */ export function createLocalizationTranslationProviderRecordType(localization_providers) {
    return createRecordType("localization_provider", {
        migrations: defineMigrations({
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(localization_providers, (_, v)=>v.migrations ?? defineMigrations({}))
        }),
        scope: "presence",
        validator: T.model("localization_provider", T.union("type", mapObjectMapValues(localization_providers, (type, { props, meta })=>createLocalizationTranslationProviderValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {},
            internalLocalizationTranslationProviderId: 0,
            visibilitySince: 0
        }));
}
